import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import uniqueId from 'lodash.uniqueid';

import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

class RawSelectInput extends React.Component {
  constructor(props) {
    super(props);

    this.id = uniqueId();
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.target.value);
  }

  render() {
    const items = this.props.items || new Map();

    let menuItems = [];
    items.forEach((label, value) => {
      menuItems.push(
        <MenuItem key={ `select-input-${this.id}-${value}` } value={ value }>{ label }</MenuItem>
      );
    });

    return (
      <Grid container className={ this.props.className }>
        <Grid item xs={12}>
          <FormControl error={ this.props.showError() } style={{ width: "100%" }}>
            <InputLabel id={ `label-select-input-${this.id}` } shrink={ items.get(this.props.getValue()) }>
              { this.props.showError() ? this.props.getErrorMessage() : this.props.label }
            </InputLabel>
            <Select
              id={ `select-input-${this.id}` }
              labelId={ `label-select-input-${this.id}` }
              value={ this.props.getValue() || '' }
              onChange={ this.changeValue }
              renderValue={ (value) => (items.get(value) || '') }
              displayEmpty={ items.get("") }
            >
            { menuItems }
          </Select>
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}

RawSelectInput.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  items: PropTypes.instanceOf(Map).isRequired,
}

export default withFormsy(RawSelectInput);

